import {parseJsonAttribute} from '../utilities/utilities';

/** Base class for animated screens of content inside the circle lockup */
export default class CircleScreen {
    /**
     * @constructor
     * @param {HTMLElement} container
     */
    constructor(container) {
        this.container = container;

        // Parse any animation parameters provided via JSON in an HTML attribute
        this.parameters = parseJsonAttribute(
            this.container,
            'data-animation',
        );
    }

    /**
     * Fades in foreground copy
     * @param {object} timeline
     * @param {number} startTime
     * @param {string} easing
     */
    show(
        timeline,
        startTime,
        easing = 'power2.out',
    ) {
        // Scale
        timeline.to(
            this.container,
            1.0,
            {
                ease: easing,
                pointerEvents: 'all',
                scale: 1,
            },
            startTime,
        );

        // Fade copy in
        timeline.to(
            this.container,
            1.0,
            {
                ease: easing,
                opacity: 1,
            },
            startTime,
        );
    }

    /**
     * Fades out foreground copy
     * @param {object} timeline
     * @param {number} startTime
     * @param {string} easing
     */
    hide(
        timeline,
        startTime,
        easing = 'power2.out',
    ) {
        // Fade copy out
        timeline.to(
            this.container,
            0.5,
            {
                ease: easing,
                opacity: 0,
                pointerEvents: 'none',
            },
            startTime,
        );
    }
}
